enum PriceModuleLayoutTypeEnum {
	subtle = 'subtle',
	default = 'default',
	emphasized = 'emphasized',
	rowPrice = 'rowPrice',
	listPrice = 'listPrice'
}

export default PriceModuleLayoutTypeEnum;
